import { FC } from 'react'
import { Button, Flex } from 'antd'
import { Link } from 'react-router'
import { spacingLG } from '@signifyd/ant'
import { HUB_LINKS } from './hub.links'

const Hub: FC = () => {
  return (
    <>
      <Flex wrap="wrap" gap={spacingLG}>
        {HUB_LINKS.map((link) => (
          <Link
            key={link.key}
            to={link.path}
            data-analytics-id={link.analyticsId}
            data-test-id={link.testId}
          >
            <Button size="large" icon={link.icon}>
              {link.label}
            </Button>
          </Link>
        ))}
      </Flex>
    </>
  )
}

export default Hub
